// Keep using mapbox-gl for the LngLatBounds value (react-map-gl exports only the type). Avoid importing it twice elsewhere.
import { LngLatBounds } from "mapbox-gl";
import bbox from "@turf/bbox";
import { DEFAULT_BEARING, DEFAULT_CENTER, DEFAULT_PITCH, DEFAULT_ZOOM, } from "../constants";
export const createInitialViewport = (geometry) => {
    const fitBoundsOptions = {
        padding: { top: 0, bottom: 0, left: 0, right: 0 },
    };
    const base = {
        zoom: DEFAULT_ZOOM,
        pitch: DEFAULT_PITCH,
        bearing: DEFAULT_BEARING,
        fitBoundsOptions,
        center: DEFAULT_CENTER,
        bounds: new LngLatBounds(DEFAULT_CENTER, DEFAULT_CENTER),
    };
    if (!geometry)
        return base;
    if (geometry.type === "Point") {
        return Object.assign(Object.assign({}, base), { center: geometry.coordinates, bounds: new LngLatBounds(geometry.coordinates, geometry.coordinates) });
    }
    if (geometry.type === "Polygon" || geometry.type === "MultiPolygon") {
        const boundsArray = bbox(geometry);
        const center = [
            (boundsArray[0] + boundsArray[2]) / 2,
            (boundsArray[1] + boundsArray[3]) / 2,
        ];
        return Object.assign(Object.assign({}, base), { center, bounds: new LngLatBounds([boundsArray[0], boundsArray[1]], [boundsArray[2], boundsArray[3]]) });
    }
    return base;
};
